import React from 'react';
import { Trans } from 'react-i18next';
import { Text } from 'mintel-react-ui';

import styles from './LoginForm.scss';

export default ({
  fedLoginLink,
  registerLink,
}: {
  fedLoginLink: string;
  registerLink: string;
}): JSX.Element => (
  <div className={styles.footer} data-testid="footer">
    <Text.Body2>
      <Trans>
        Need federated login? <a href={fedLoginLink}>Login here</a>
      </Trans>
    </Text.Body2>
    <br />
    <Text.Body2>
      <Trans>
        New to Mintel? <a href={registerLink}>Register</a>
      </Trans>
    </Text.Body2>
  </div>
);
